(() => {
  document.querySelectorAll('[data-r70pm]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const dialog = root.querySelector('dialog');
    const trigger = root.querySelector('[data-r70pm-open]');
    const variants = JSON.parse(root.querySelector('[data-pm-variants]').textContent);
    const sync = () => {
      const selected = document.querySelector('form[action*="/cart/add"] [name="id"]');
      const id = selected?.value || new URL(location.href).searchParams.get('variant');
      const variant = variants.find(v => String(v.id) === String(id)) || variants.find(v => String(v.id) === root.querySelector('[data-pm-variant-id]').value);
      if (!variant) return;
      root.querySelector('[data-pm-variant-id]').value = variant.id;
      const variantTitle = variant.public_title || variant.title;
      root.querySelector('[data-pm-variant]').value = !variantTitle || variantTitle === 'Default Title' ? '選択肢なし（単一仕様）' : variantTitle;
      root.querySelector('[data-pm-sku]').value = variant.sku || '';
      root.querySelector('[data-pm-price]').value = new Intl.NumberFormat('ja-JP', {style:'currency',currency:'JPY'}).format(variant.price / 100) + ' JPY';
      const url = new URL(root.querySelector('[data-pm-url]').value);
      url.searchParams.set('variant', variant.id);
      root.querySelector('[data-pm-url]').value = url.href;
    };
    trigger.addEventListener('click', () => { sync(); dialog.showModal(); });
    root.querySelector('[data-r70pm-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => trigger.focus());
    dialog.querySelector('form')?.addEventListener('submit', sync);
    if (root.querySelector('[data-pm-result]') && location.hash === '#' + dialog.querySelector('form').id) {
      dialog.showModal();
      root.querySelector('[data-pm-result]').focus();
    }
  });
})();
